import React from 'react';
import { ProductInterface } from 'modules/product/interfaces/product.interface';
import { ProductVariantDataInterface } from 'modules/product/interfaces/product-variants.interface';
import { getBaseProductStructuralData, MAX_DESCRIPTION_LENGTH } from 'helpers/get-product-structural-data';
import { trimLength } from 'helpers/string-tools';
import dayjs from 'helpers/dayjs';

const CATEGORY_SMARTPHONES_ID = 'c200';

const getMostRatedVariant = (products: ProductVariantDataInterface[]) => {
    return products.reduce((mostPopular, product) =>
        product.opinions.average > mostPopular.opinions.average ? product : mostPopular
    , products[0]);
};

const ProductVariantsStructuralData: React.FC<{
    product: ProductInterface;
}> = ({ product }) => {
    if (!product || product.variants.count === 0 || product.category?.id !== CATEGORY_SMARTPHONES_ID) {
        return null;
    }

    const mostRatedVariantProduct = getMostRatedVariant(product.variants.products);

    if (mostRatedVariantProduct.id !== product.id) {
        return null;
    }

    const data = {
        '@context': 'https://schema.org/',
        '@type': 'ProductGroup',
        'name': product.name,
        'description': trimLength(product.description.text, MAX_DESCRIPTION_LENGTH),
        'productGroupID': product.id,
        'brand': {
            '@type': 'Brand',
            'name': product.producer.name
        },
        'hasVariant': product.variants.products.map((variant) => {
            return variant.offers.count
                ? {
                    ...getBaseProductStructuralData(variant),
                    offers: variant.offers.items.map((offer) => ({
                        '@type': 'Offer',
                        'priceCurrency': 'PLN',
                        'price': offer.price,
                        'priceValidUntil': dayjs().add(1, 'month').toISOString(),
                        'availability': 'https://schema.org/InStock'
                    }))
                }
                : void 0;
        })
    };

    return (
        <script
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
            type="application/ld+json"
        />
    );
};

export default ProductVariantsStructuralData;
